export default {
  teamEdited: {
    status: true,
    teamDefinition: '',
    team: '',
    driverUser: '',
    paramedicUser: null,
    orders: [],
    vehicle: {},
    teamStartedAt: null,
    teamEndedAt: null,
  },
  teams: [],
  activeTeams: [],
  statisticsCurrent: {
    total: 0,
    available: 0,
  },
}
